<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.previewModeActive]: previewModeActive
      }
    ]"
  >
    <CreateCustomer
      v-if="showCreateCustomerModal"
      :modalData="customerData"
      @submit="onCustomerCreated"
      @close="showCreateCustomerModal = false"
    />
    <div :class="$style.header">
      <BaseHeading>
        {{ filters.capitalize($t('global.items.customer', 1)) }}
      </BaseHeading>
    </div>
    <div :class="$style.main">
      <div v-if="!formData.customerId">
        <CustomerSearch
          showCreate
          @select="setCustomerData($event)"
          v-test="'appointment-customer-search'"
        />
      </div>
      <CustomerDetails
        v-else
        :options="['view', 'edit', 'remove']"
        :customer="customerData"
        :appointmentStartAt="formData.startAt"
        showAlertNotes
        @select="onCustomerMoreClick"
        v-test="'appointment-customer'"
      />
    </div>
    <div
      v-if="!formData.customerId"
      :class="$style.addCustomer"
    >
      <BaseText
        inline
        @click="showCreateCustomerModal = true"
        v-test="'appointment-customer-new'"
      >
        + {{ $t('appointment.create.add_new_customer') }}
      </BaseText>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import CustomerDetails from '@/components/customer/customer-details/index.vue';
import CustomerSearch from '@/components/customer-search/index.vue';
import filters from '@/filters';
import CreateCustomer from '@/modals/create-customer/index.vue';
import { useCreateAppointmentStore } from '@/stores/calendar-create-appointment';
import { useCalendarPreviewStore } from '@/stores/calendar-preview';

const showCreateCustomerModal = ref(false);
const { previewModeActive } = storeToRefs(useCalendarPreviewStore());

const { formData, customerData, setCustomerData } = useCreateAppointmentStore();
const router = useRouter();

const onCustomerCreated = (customer: any) => {
  setCustomerData(customer);
  showCreateCustomerModal.value = false;
};

const onCustomerMoreClick = (option: string) => {
  switch (option) {
    case 'edit':
      showCreateCustomerModal.value = true;
      break;
    case 'remove':
      setCustomerData();
      break;
    case 'view':
      router.push({
        name: 'customer-overview',
        params: { customerId: formData.customerId },
      });
      break;
  }
};
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.main {
  width: 100%;

  .base.previewModeActive & {
    order: 2;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .base:not(.smallScreen) & {
    margin-bottom: $spacing * 0.5;
  }

  .base.smallScreen & {
    margin-bottom: $spacing;
  }
}

.addCustomer {
  .base:not(.previewModeActive) & {
    margin-top: $spacing;
  }

  .base.previewModeActive & {
    order: 1;
  }
}
</style>
